<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="加工组织">
              <global-select
                :value.sync="queryParams.organizationCode"
                selectType="selectAssembleMultipleSearch"
                requestApi="/system/user/inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                :assembleLabel="true"
                searchParam="organizationName"
                :setParams="{ pageSize: 9999999 }"
                @change="getBomWorkshopFindList"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="车间编码">
              <a-select v-model="queryParams.workshopCode" option-filter-prop="children" option-label-prop="label" mode="multiple" :max-tag-text-length="2" :max-tag-count="1">
                <a-select-option v-for="(item) in workshopCodeList" :key="item.workshopCode" :value="item.workshopCode" :label="item.workshopCode">
                  {{ item.workshopCode }}-{{ item.workshopDesc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="车间类型">
              <a-select v-model="queryParams.workshopType">
                <a-select-option v-for="(item) in workshopTypeList" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="状态">
              <a-select v-model="queryParams.workshopStatus" allowClear>
                <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiBomWorkshopNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['bom:bomWorkshop:add']">新建</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['bom:bomWorkshop:import']">导入</a-button>
      <a-button @click="handleExport" v-hasPermi="['bom:bomWorkshop:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['bom:bomWorkshop:template']">下载模板</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <!-- <a-table
          ref="table"
          :columns="columns"
          :loading="pageParams.tableLoading"
          :data-source="typeList"
          :pagination="false"
          :scroll="{ x: 1800 }"
          row-key="id"
        >
          <div
            v-for="item in columns"
            :slot="item.dataIndex"
            slot-scope="text, record"
            :key="item.dataIndex"
          >
            <span v-if="item.dataIndex === 'operation'">
              <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['bom:bomWorkshop:edit']">编辑</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
            <span v-else-if="item.dataIndex === 'workshopMcName'">
              <span v-if="!isEdit || currentId !== record.id">{{ meaning(record, item.dataIndex) }}</span>
            <global-select
              v-if="isEdit && currentId === record.id"
              :value.sync="record[item.dataIndex]"
              size="small"
              selectType="selectAssembleSearch"
              requestApi="/scp/scpMrpPlans/plannerBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              searchParam="itemCode" />
            </span>
            <span v-else-if="item.type === 'select'">
              <span v-if="!isEdit || currentId !== record.id">{{ meaning(record, item.dataIndex) }}</span>
              <a-select v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" @change="selectChange(record, item.dataIndex)">
                <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
              </a-select>
            </span>
            <span v-else-if="item.type === 'input'">
              <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
              <a-input v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" size="small" />
            </span>
            <span v-else-if="item.type === 'switch'">
              <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.workshopStatus === 'Y'" @change="statusOnChange(record)" />
            </span>
            <span v-else-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
            <span v-else>{{ text }}</span>
          </div>
        </a-table> -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.FACTORY_ASSEMBLY_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)" v-hasPermi="['bom:bomWorkshop:edit']">编辑</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
                <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
              </span>
              <span v-if="item.dataIndex === 'ljZcbcpType'">
                 <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.ljZcbcpTypeName }}</span>
                <global-select
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record[item.dataIndex]"
                  :selectData="partsList"
                  selectType="selectFilter"
                  :allowClear="true"
                  @change="(val) => partsChange(val, text.record)"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                />
              </span>
              <span v-else-if="item.dataIndex === 'workshopMcName'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <global-select
                  class="workshop-mc-name-selector"
                  v-if="isEdit && currentId === text.record.id"
                  :value.sync="text.record[item.dataIndex]"
                  size="small"
                  @change="(val, selectList)=>workshopMcNameChange(val, selectList,text.record)"
                  selectType="selectAssembleSearch"
                  requestApi="/bom/bomWorkshop/findWorkshopMc"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="inputString" />
              </span>
              <span v-else-if="item.type === 'select'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ meaning(text.record, item.dataIndex) }}</span>
                <a-select v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" @change="selectChange(text.record, item.dataIndex)">
                  <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
                </a-select>
              </span>
              <span v-else-if="item.type === 'input'">
                <span v-if="!isEdit || currentId !== text.record.id">{{ text.record[item.dataIndex] }}</span>
                <a-input v-if="isEdit && currentId === text.record.id" v-model="text.record[item.dataIndex]" size="small" />
              </span>
              <span v-else-if="item.type === 'switch'">
                <a-switch :disabled="!isEdit || currentId !== text.record.id" :checked="text.record.workshopStatus === 'Y'" @change="statusOnChange(text.record)" />
              </span>
              <span v-else-if="item.type === 'text'">{{ text.text && $moment(text.text).format('YYYY-MM-DD HH:mm') }}</span>
              <span v-else>{{ text.text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <factory-assembly-add
          ref="createModal"
          :inventOrg="inventOrg"
          :workshopTypeList="workshopTypeList"
          :partsList="partsList"
          @handle-success="handleOk"
        />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiBomWorkshopUpdate, apiJobClassPullDownList, apiBomWorkshopFindList, apiBomWorkshopList, apiBomWorkshopNewExport } from '@/api/mes/basedata/factoryAssembly'
import FactoryAssemblyAdd from './components/factory-assembly-add'
import Cookies from 'js-cookie';
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  name: 'FactoryAssembly',
  components: {
    DownloadModal,
    FactoryAssemblyAdd
  },
  mixins: [cacheRequest],
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiBomWorkshopNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiBomWorkshopList, true),
        pageCurrent: true
      },
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomWorkshop/import'
      },
      isEdit: false,
      currentId: "",
      pageParams: {
        automatic: true,
        pageUrl: '/bom/bomWorkshop/list',
        tableLoading: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        workshopCode: undefined,
        workshopType: undefined,
        workshopStatus: undefined
      },
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '车间类型',
          dataIndex: 'workshopType',
          ellipsis: true,
          stickyFixed: 'left',
          scopedSlots: { customRender: 'workshopType' },
          width: 160,
          align: 'center',
          type: "select",
          dataList: 'workshopTypeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '加工组织',
          dataIndex: 'organizationName',
          stickyFixed: 'left',
          scopedSlots: { customRender: 'organizationName' },
          width: 160,
          align: 'center'
          // type: "select",
          // dataList: 'inventOrg',
          // value: 'realValue',
          // label: 'label'
        },
        {
          title: '供应商',
          width: 250,
          dataIndex: 'supplierName',
          align: 'center'
        },
        {
          title: '零部件类型',
          width: 120,
          dataIndex: 'ljZcbcpType',
          scopedSlots: { customRender: 'ljZcbcpType' },
          align: 'center'
        },
        {
          title: '车间编码',
          dataIndex: 'workshopCode',
          width: 120,
          align: 'center'
        },
        {
          title: '车间说明',
          width: 120,
          dataIndex: 'workshopDesc',
          scopedSlots: { customRender: 'workshopDesc' },
          ellipsis: true,
          align: 'center',
          type: "input"
        },
        {
          title: '财务车间编码',
          width: 120,
          dataIndex: 'finWorkCode',
          scopedSlots: { customRender: 'finWorkCode' },
          ellipsis: true,
          align: 'center',
          type: "input"
        },
        {
          title: '车间物控',
          dataIndex: 'workshopMcName',
          scopedSlots: { customRender: 'workshopMcName' },
          width: 180,
          align: 'center',
          type: "select",
          dataList: 'workshopMcNameList',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '默认工单分类',
          dataIndex: 'defaultJobClass',
          scopedSlots: { customRender: 'defaultJobClass' },
          width: 150,
          align: 'center',
          type: "select",
          dataList: 'defaultJobClassList',
          value: 'realValue',
          label: 'label'
        },
        {
          title: '状态',
          width: 120,
          dataIndex: 'workshopStatus',
          scopedSlots: { customRender: 'workshopStatus' },
          align: 'center',
          type: "switch"
        },
        {
          title: '最后修改人',
          width: 120,
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center',
          type: "text"
        },
        {
          title: '创建人',
          width: 120,
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center',
          type: "text"
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      partsList: [], // 零部件类型列表
      workshopTypeList: [], // 车间类型
      workshopCodeList: [], // 车间编码
      defaultJobClassList: [], // 默认工单分类
      workshopMcNameList: [] // 车间物控(缺接口数据)
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.getBomWorkshopFindList()
    this.cacheLookupRequest('MES_ITEM_ZCBCP_TYPE', { lookupType: 'MES_ITEM_ZCBCP_TYPE', current: 1, pageSize: 999 }, 'partsList')
    this.cacheLookupRequest('MES_WORKSHOP_TYPE', { lookupType: 'MES_WORKSHOP_TYPE', current: 1, pageSize: 999 }, 'workshopTypeList')
    // this.getLookupList('MES_WORKSHOP_TYPE', 'workshopTypeList')
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 零部件类型选择
    partsChange(val, record) {
      const selectedElement = this.partsList?.find(item => item.lookupCode === val)
      // record.ljZcbcpType = selectedElement?.realValue || ''
      record.ljZcbcpTypeName = selectedElement?.lookupValue || ''
    },
    // 车间物控
    workshopMcNameChange (val, selectList, record) {
      const selectedElement = selectList.find(item => item.realValue === val);
      if (selectedElement) {
        record.workshopMcName = selectedElement.realValue
        record.workshopMcCode = selectedElement.label
      }
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
      this.isEdit = false;
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.getJobClassPullDownList(record.organizationCode)
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.workshopType) {
        this.$message.warning('车间类型不能为空')
        return
      }
      if (!record.defaultJobClass) {
        this.$message.warning('默认工单分类不能为空')
        return
      }
      if (!record.workshopDesc) {
        this.$message.warning('车间说明不能为空')
        return
      }
      if (!record.workshopMcName || !record.workshopMcCode) {
        record.workshopMcCode = undefined
        record.workshopMcName = undefined
      }
      apiBomWorkshopUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.onSearch()
    },
    /** 查询列表 */
    getList (data) {
      this.typeList = data
      this.isEdit = false
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        organizationCode: undefined,
        workshopCode: undefined,
        workshopType: undefined,
        workshopStatus: undefined
      }
      this.handleQuery()
    },
    statusOnChange (row) {
      row.workshopStatus = row.workshopStatus === 'Y' ? 'N' : 'Y'
    },
    selectChange (record, dataIndex) {
      if (dataIndex === "organizationName") {
        record.defaultJobClass = ""
        this.getJobClassPullDownList(record.organizationCode)
      }
    },
    // 默认工单分类
    getJobClassPullDownList (code) {
      const arr = []
      arr.push(code)
      apiJobClassPullDownList({ organizationCodeList: arr }).then(res => {
        if (res.data && res.data.length > 0) {
          this.defaultJobClassList = res.data
        } else {
          this.defaultJobClassList = []
        }
      })
    },
    // 车间编码
    getBomWorkshopFindList () {
      apiBomWorkshopFindList({ organizationCode: this.queryParams.organizationCode }).then(res => {
        this.workshopCodeList = res
      })
    },
    meaning (record, dataIndex) {
      if (dataIndex === "defaultJobClass") {
        return record.defaultJobClassDesc
      }
      if (dataIndex === "workshopType") {
        return record.workshopTypeDesc
      }
      return record[dataIndex]
    },
    setArray (arr) {
      return this[arr]
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('bom/bomWorkshop/template', {
        ...this.queryParams
      }, `车间导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('bom/bomWorkshop/export', {
      //   ...this.queryParams
      // }, `车间_${new Date().getTime()}.xlsx`)
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.page-header-content{
  /deep/.ant-select{
    width: 120px !important;
  }
  .workshop-mc-name-selector {
    /deep/.ant-select{
      width: 140px !important;
    }
  }
  input{
    width: 100px;
  }
  /deep/.ant-input-number{
    width: 100px;
  }
}
/deep/.ant-drawer-content-wrapper{
  .ant-drawer-body{
    .ant-form-item-children{
      .ant-select{
        width: 260px !important;
      }
    }
  }
}

</style>
